<template>
  <b-container fluid>
    <b-form-row>
      <b-col lg="3" md="4" sm="12">
        <b-form-group v-bind:id="'qty-' + key" 
        :label="index == 0 ? 'Quantities & Units:' : ''"
        v-bind:label-for="'input-qty-' + key" label-class="quote-summary-label" variant="danger">
          <b-form-input
             size="sm"
              v-bind:class="'quote-summary-value ' + getNoQuoteClass" 
            v-bind:id="'input-qty-' + key"
            v-model="qty_label"
            v-bind:plaintext="true"
            disabled
            
          ></b-form-input>
        </b-form-group>
      </b-col>
      
      <b-col lg="3" md="4" sm="12">
        <b-form-group v-bind:id="'lead_time-' + key" 
        :label="index == 0 ? 'Lead Time:' : ''"
        v-bind:label-for="'input-lead_time-' + key" label-class="quote-summary-label">
          <b-input-group>
            <b-form-input
              size="sm"
              v-bind:class="'quote-summary-value ' + getNoQuoteClass" 
              v-bind:id="'input-lead_time-' + key"
              v-model="lead_time_label"
              v-bind:plaintext="true"
              disabled
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="3" md="4" sm="12">
        <b-form-group v-bind:id="'cost-' + key"  
        :label="index == 0 ? 'Unit Cost:' : ''"
        v-bind:label-for="'input-cost-' + key" label-class="quote-summary-label">
          <b-input-group>
            <b-form-input
             size="sm"
              v-bind:class="'quote-summary-value ' + getNoQuoteClass" 
              v-bind:id="'input-cost-' + key"
              v-model="cost_label"
              v-bind:plaintext="true"
              disabled
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="3" md="6" sm="12">
        <b-form-group v-bind:id="'condition-' + key"  
        :label="index == 0 ? 'Condition:' : ''"
        v-bind:label-for="'input-condition-' + key" label-class="quote-summary-label">
          <b-form-input
             size="sm"
              v-bind:class="'quote-summary-value ' + getNoQuoteClass" 
            v-bind:id="'input-condition-' + key"
            v-model="condition_label"                      
            v-bind:plaintext="true"
            disabled
          ></b-form-input>        
        </b-form-group>        
      </b-col>

    </b-form-row>

    <b-form-row v-if="response.custom_fields && Object.keys(response.custom_fields).length>0">
      <b-col lg="4" md="4" sm="12" v-for="(value, custom_field_key, custom_fields_index) in response.custom_fields" :key="custom_fields_index">
        <b-form-group v-bind:id="custom_field_key + key" v-bind:label="custom_field_key + ':'" v-bind:label-for="'input-' + custom_fields_index + '-' + key" label-class="quote-summary-label">
          <b-form-input
             size="sm"
             class="quote-summary-value" 
            v-bind:id="'input-' + custom_field_key + '-' + key"
            v-bind:value="value"
            v-bind:plaintext="true"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>

  </b-container>
</template>

<script>
export default {
  name: 'quote-read-quantity',
  props: [
    'response',
    'line',
    'index'
  ],
  computed: {
    key: function() {
      return "quote_" + this.line +"_quantity_" + this.index;
    },
    lead_time_label: function() {
      return this.response.lead_time ? this.response.lead_time + " Days" : "";
    },
    cost_label: function() {
      return this.response.cost ? new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(this.response.cost) : "";
    },
    qty_label: function() {
      var label = this.response.qty && this.response.uom ? this.response.qty + " " + this.response.uom : '';
      if(this.response.no_quote == true) { label += " (no-quoted)" }
      console.log(this.response);
      return label;
    },
    condition_label: function() {
      console.log(this.response.condition);
      if(this.response.condition === "NEW") { return "Factory New"; }
      if(this.response.condition === "SURPLUS") { return "Surplus"; }
      // otherwise
       return "Refurbished"; 
    },
    getNoQuoteClass: function() {
      var result = '';
      if(this.response.no_quote == true) { result = 'noQuoteStyle'; }
      return result;
    }
  }
}
</script>

<style scoped>

 .form-control-plaintext.form-control-sm {
   padding-left: 9px !important;
 }
 .form-group {
    margin-bottom: 0.2rem;
}

.noQuoteStyle {
  background-color: #eeeeee;
  font-style: italic;
  color: #555555;
}
</style>